// @flow

import { fragments as embroideryOrderStatusFragments } from "../../application/apps/EmbroideryApp/components/EmbroideryOrderStatus/graph";
import { gql } from "@apollo/client";
import { graphql } from '@apollo/client/react/hoc';

const markOrderAsTrimmingCompleted: any = graphql(
  gql`
    mutation($orderId: ID!) {
      markOrderAsTrimmingCompleted(orderId: $orderId) {
        errors {
          orderId
        }
        order {
          ...EmbroideryOrderStatus_order
        }
        succeeded
      }
    }
    ${embroideryOrderStatusFragments.order}
  `,
  {
    name: "markOrderAsTrimmingCompleted"
  }
);

export default markOrderAsTrimmingCompleted;
